import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { ElisClientError } from '@rossum/api-client/errors';
import { Queue, QueueListQuery } from '@rossum/api-client/queues';
import { api } from '../../lib/apiClient';

export const QUERY_KEY_QUEUES_UNPAGINATED = 'queues-unpaginated';

type UseUnpaginatedQueuesQuery = Omit<QueueListQuery, 'pageSize' | 'page'>;

export const useUnpaginatedQueues = <TReturnedData = Queue[]>(
  query: UseUnpaginatedQueuesQuery = {},
  queryOptions: Omit<
    UseQueryOptions<
      Queue[],
      ElisClientError,
      TReturnedData,
      [typeof QUERY_KEY_QUEUES_UNPAGINATED, UseUnpaginatedQueuesQuery]
    >,
    'queryKey' | 'queryFn'
  > = {}
) =>
  useQuery({
    queryKey: [QUERY_KEY_QUEUES_UNPAGINATED, query],
    queryFn: () =>
      api.unpaginatedRequest(endpoints.queues.list)({
        pageSize: 100,
        ...query,
      }),
    ...queryOptions,
  });
